export const FourwavesTaxNumbers = {
  gst: '830853982RT0001',
  qst: '1221922481TQ0001',
  hst: '830853982RT0001',
};
